/* P1 of GH-1133 (#1150): the card gate's onboarding OAuth-return
   passthrough. RequireActiveBilling (App.jsx) renders this instead of the
   card wall when a card-less ('new') account comes back from the onboarding
   connect step's social OAuth (lib/onboardingSocialReturn.js
   isOnboardingSocialReturn). It does what MainApp's resume branch does for
   every other account — consume the one-shot flag and replace the return
   URL with /onboarding?continue=activation&… — without first mounting the
   app behind the wall. The wall itself is unchanged and shows again when
   the user leaves onboarding for /app. */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { browserStorage, clearOnboardingSocialReturn, onboardingSocialResumePath } from '../lib/onboardingSocialReturn.js';

export default function OnboardingSocialResume({ children = null }) {
  const location = useLocation();
  const navigate = useNavigate();
  const target = onboardingSocialResumePath(location.search);

  useEffect(() => {
    clearOnboardingSocialReturn(browserStorage());
    navigate(target, { replace: true });
  }, [navigate, target]);

  return children;
}
